export var ICON_STATUS_TYPES = Object.freeze({
  info: 'info',
  success: 'success'
});